module.exports = __webpack_public_path__ + "static/img/6.d62ed15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/6.png
// module id = ZI3E
// module chunks = 0